import { render, staticRenderFns } from "./SiteTypeMenu.vue?vue&type=template&id=fe24f848&scoped=true"
import script from "./SiteTypeMenu.vue?vue&type=script&lang=js"
export * from "./SiteTypeMenu.vue?vue&type=script&lang=js"
import style0 from "./SiteTypeMenu.vue?vue&type=style&index=0&id=fe24f848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe24f848",
  null
  
)

export default component.exports